import router from "@/lib/workspace-router";
import { toast } from "sonner";
import {
  appFinancialAccounts,
  appIncomes,
  appExpensePayments,
  appOtherMovements,
  appTransfers,
} from "@/api";

export const financialClients = {
  financial_account: appFinancialAccounts,
  income: appIncomes,
  expense_payment: appExpensePayments,
  other_movement: appOtherMovements,
  transfer: appTransfers,
} as const;
export type FinancialKind = keyof typeof financialClients;
export const financialLabels: Record<FinancialKind, string> = {
  financial_account: "Financial Account",
  income: "Income",
  expense_payment: "Expense Payment",
  other_movement: "Other movement",
  transfer: "Transfer",
};
export interface FinancialModalHandle {
  close: () => void;
  afterLeave: () => void;
  getParentModal?: () => FinancialModalHandle | null | undefined;
  modalContext?: { response: { baseUrl?: string } } | null;
}
export interface CurrencyGroup {
  currency: string;
  amount_cents: number;
  subunit_to_unit: number;
}
export function financialError(error: unknown) {
  const errors = (error as { body?: { errors?: Record<string, string[]> } })
    ?.body?.errors;
  return errors;
}
export function financialViewUrl() {
  const { pathname, search } = window.location;
  return /^\/(?:accounts(?:\/fac_[a-z0-9]+)?|income|expenses(?:\/exp_[a-z0-9]+)?|)$/.test(
    pathname,
  )
    ? pathname + search
    : undefined;
}
export function refreshFinancialView(
  modal: FinancialModalHandle | null,
  fallback: string,
  deletedId?: string,
  origin?: string,
) {
  let target = modal?.modalContext?.response.baseUrl || origin || fallback;
  if (deletedId && target.includes(deletedId)) target = fallback;
  router.clearHistory();
  let root = modal;
  let parent = root?.getParentModal?.();
  while (parent) {
    root = parent;
    parent = root.getParentModal?.();
  }
  root?.close();
  const failed = () => {
    toast.error(
      "The change saved, but balances could not refresh. Reload this page.",
    );
    return false;
  };
  router.visit(target, {
    preserveScroll: true,
    replace: true,
    onSuccess: () => root?.afterLeave(),
    onError: failed,
    onHttpException: failed,
    onNetworkError: failed,
  });
}

export function installFinancialHistoryRefresh() {
  let historyReturn = false;
  window.addEventListener("popstate", () => {
    historyReturn = true;
  });
  router.on("navigate", () => {
    if (!historyReturn) return;
    historyReturn = false;
    if (
      !/^\/(?:accounts(?:\/|$)|income(?:\/|$)|expenses(?:\/|$)|$)/.test(
        window.location.pathname,
      )
    )
      return;
    router.reload({
      onNetworkError: () => {
        toast.error("Balances could not refresh. Reload this page.");
        return false;
      },
      onHttpException: () => {
        toast.error("Balances could not refresh. Reload this page.");
        return false;
      },
    });
  });
}
